const styles = {
  wrapper: 'bg-black teair:bg-air-deepBlue',
  container:
    'container 2xl:max-w-none xl:max-w-5xl lg:max-w-3xl md:max-w-none relative',
  imageContainer: 'content-box mx-auto max-w-4xl',
  image: 'flex rounded-4 overflow-hidden',
};

export default styles;
